export default {
  navigation: {
    myContentCreatorStudio: "Content Managements", // Content & Copyright Management
    worksManagement: "Works Management",
    registerWorks: "Register Works",
    manageCatalog: "Catalog Management",
    updateMetadata: "Update Metadata",
    publishContent: "Publish Content", //Publish Works

    paymentsRevenue: "Payments & Revenue",
    paymentDashboard: "Payment Dashboard",
    myLicenses: "My Licenses",
    myInvoices: "My Invoices",
    installmentPayments: "Payment Settings",
    refundManagement: "Refund Requests & Processing",
    revenueAndPayments: "Revenue & Payments",
    revenueStatistics: "Revenue Statistics",
    copyrightPayout: "Copyright Payout",

    protectionSupport: "Protection Support",
    rightsProtection: "Rights Protection",
    violationReportsManagement: "Manage Violation Reports",
    myReports: "My Reports",
    reportViolation: "Submit Violation",
    createDispute: "Submit a Copyright Dispute",
    identityProtectionCenter: "Identity Protection Hub",
    aiAutoScan: "AI Detection",

    licensingContracts: "Licensing Contracts",
    licenseStore: "License Store",
    discoverWorks: "Explore Copyrighted Works",
    licensePurchase: "License Purchase",
    payments: "Copyright Payments",
    requestMarketplaceLicense: "Request a License",
    myMarketplaceRequests: "My License Requests",

    contractManagement: "Contract Management",
    viewContracts: "View current Contracts",
    manageContracts: "Renew/Cancel Contracts",

    documents: "Document Management",
    allDocuments: "Document Library",
    uploadDocument: "Upload Document",
    myDocuments: "My Documents",
    purchasedDocuments: "Purchased Documents",

    systemAdministration: "System Administration",
    userManagement: "User Management",
    systemConfiguration: "System Configuration",
    activityLogs: "Activity Logs",
    apiManagement: "API Management",

    staffTasks: "Staff Tasks",
    processContracts: "Process Contracts",
    contentModeration: "Content Moderation",
    customerSupport: "Customer Support",

    monitoring: "Violation Monitoring",
    aiScan: "AI Violation Scan",
    warnings: "Send Violation Warnings",
    revocation: "License Revocation",

    legal: "Legal Processing",
    disputes: "Dispute Resolution",
    violations: "Violation Handling",
    enforcement: "Copyright Law Enforcement",

    explore: "Explore",
    exploreDiscoverWorks: "Discover Works",
    licenseInfo: "Licensing Information",

    documents2: "Documents",
    allDocuments2: "Document Library",
    searchDocuments: "Search Documents",

    business: "Business Development",
    contractManagement2: "Contract Management",
    partnershipManagement: "Partnership Management",
    growthManagement: "Growth Management",

    support: "Support & Control",
    techSupport: "Technical Support",
    faqHelp: "Frequently Asked Questions",
    userOnboarding: "New User Onboarding",

    security: "Security & Risk",
    monitorSecurity: "Security Monitoring",
    implementSecurity: "Security Implementation",
    analyzeRisk: "Risk Analysis",
    preventRisk: "Risk Prevention",

    violationDashboard: "Violation Dashboard",
    legalViolations: "Legal Violations",

    certificatesCompliance: "Certificates",
    certificateManagement: "Certificate Management",
    vietrroCertificate: "Vietrro Certificate",
    wipoCertificate: "WIPO Certificate",
    noipCertificate: "NOIP Certificate",
    associationLicenses: "Association Licenses",
    licenseApproval: "License Approval",
    certificateVerification: "Certificate Verification",
    licenseTracking: "License Tracking",
    licenseHistory: "License History",

    certificateIntegrations: "Certificate Integrations",
    vietrroWipoIntegration: "VIETRRO/WIPO Integration",
    wipoIntegration: "WIPO Integration",
    vietrroIntegration: "VIETRRO Integration",
    noipIntegration: "NOIP Integration",
    associationIntegration: "Association Integration",

    certificateApproval: "Certificate Approval",
    certificateHistoryAdmin: "Certificate History Admin",
    certificateVerificationAdmin: "Certificate Verification Admin",

    certificateMonitoring: "Certificate Monitoring",
    certificateVerificationMonitor: "Certificate Verification Monitor",
    licenseTrackingMonitor: "License Tracking Monitor",

    certificatePublic: "Certificate Public",
    certificateVerificationPublic: "Certificate Verification Public",

    marketplace: "Marketplace",
    marketplaceHome: "Activity",
    browseContent: "Buy/Sell",
    marketplaceDashboard: "Management",

    creatorTools: "Creator Tools",
    creatorDashboard: "Creator Dashboard",
    contentManagement: "Content Management",
    creatorAnalytics: "Creator Analytics",
    incomingRequests: "Incoming Requests",
    payoutManagement: "Payout Management",

    preLicenseSystem: "Pre-license System",
    searchInternationalWorks: "Search International Works",
    preLicenseRequest: "Pre-license Request",
    trackPreLicense: "Track Pre-license Progress",

    authorFinder: "Author Finder",
    browseUnclaimedContent: "Browse Unclaimed Content",
    vietrroVault: "Vietrro Vault",
    orphanContent: "Orphan Content",
    myClaimRequests: "My Claim Requests",
    contentVerification: "Content Verification",

    marketplaceAdministration: "Marketplace (A)",
    marketplaceDashboardAdmin: "Marketplace Dashboard",
    marketplaceContentModeration: "Content Moderation",
    claimReviewAdministration: "Claim Review",
    marketplaceAnalytics: "Marketplace Analytics",
    paymentConfirmation: "Payment Confirmation",

    adminPaymentManagement: "Payment Managements",
    paymentOverview: "Payment Overview",
    paymentVerification: "Payment Verification",
    transactionManagement: "Transaction Managements",
    refundApproval: "Refund Approval",
    
    adminDisputeManagement: "Dispute Management",
    disputeQueue: "Dispute Management Queue",

    adminLicenseMonitoring: "License Monitoring",
    licenseActivationMonitor: "License Activation Tracker",

    marketplaceMonitoring: "Marketplace (M)",
    marketplaceViolations: "Marketplace Violations",
    marketplaceContentScanning: "Marketplace Content Scanning",

    marketplaceLegal: "Marketplace (L)",
    marketplaceDisputes: "Marketplace Disputes",
    marketplaceCompliance: "Marketplace Compliance",
    claimReviewLegal: "Claim Review",

    marketplaceBusiness: "Marketplace (B)",
    marketplacePartnerships: "Marketplace Partnerships",
    marketplaceRevenue: "Marketplace Revenue",
    marketplaceGrowthAnalysis: "Marketplace Growth Analysis",

    marketplaceSecurity: "Marketplace (S)",
    marketplaceFraudDetection: "Fraud Detection",
    marketplaceRiskAssessment: "Risk Assessment",
    marketplaceSecurityMonitoring: "Marketplace Monitoring",

    marketplacePublic: "Marketplace (P)",
    browseMarketplace: "Browse Marketplace",
    searchContent: "Search Content",
    authorFinderPublic: "Author Finder",
    verifyContent: "Verify Content Authenticity"
  },
};
